module.exports = __webpack_public_path__ + "img/cloud.432da55.png";